import { z } from 'zod';
import { persistedTimestampSchema } from '../shared/firestore-timestamp.schema.js';
/** Dernier événement remonté par DPD, conservé séparément du statut métier BeFret. */
export const dpdStatusSnapshotSchema = z
    .object({
    current: z.string().min(1),
    lastUpdate: z.string().datetime(),
    location: z.string(),
    eventDescription: z.string(),
})
    .strict();
/** Trace des synchronisations planifiées, notamment pour rendre la temporisation observable. */
export const dpdSyncSchema = z
    .object({
    lastAttemptAt: persistedTimestampSchema.optional(),
    lastOutcome: z.enum(['ok', 'error']),
    consecutiveFailures: z.number().int().nonnegative(),
    lastError: z.string().max(500).optional(),
})
    .strict();
/** Résultat cumulé des tentatives de reprogrammation d’une collecte à domicile. */
export const collectionRescheduleSchema = z
    .object({
    status: z.enum(['success', 'failed']),
    requestedDate: z.string().min(1),
    attempts: z.number().int().positive(),
    lastAttemptAt: persistedTimestampSchema,
    requestedBy: z.string().min(1),
    dpdReference: z.string().optional(),
    errorCode: z.string().optional(),
    errorMessage: z.string().optional(),
})
    .strict();
/**
 * Résolution d’une référence de collecte vers le numéro de colis réellement suivi par DPD.
 * Les échecs restent persistés afin qu’un colis bloqué soit retrouvable par le support.
 */
export const parcelLabelResolutionSchema = z
    .object({
    status: z.enum(['resolved', 'failed']),
    resolvedAt: persistedTimestampSchema.optional(),
    cause: z.string().optional(),
    errorCode: z.string().optional(),
    errorMessage: z.string().optional(),
    attempts: z.number().int().positive().optional(),
    lastAttemptAt: persistedTimestampSchema.optional(),
})
    .strict();
/**
 * Données ajoutées au shipment standard après création chez DPD. Les champs restent
 * optionnels car la création, le stockage du label et la première synchronisation sont asynchrones.
 */
export const dpdCarrierDataSchema = z
    .object({
    dpdShipmentId: z.string().min(1).optional(),
    dpdTrackingNumber: z.string().min(1).optional(),
    collectionRequestId: z.string().min(1).optional(),
    labelUrl: z.string().optional(),
    labelPdf: z.string().optional(),
    labelStorageUrl: z.string().optional(),
    labelPublicUrl: z.string().optional(),
    trackingUrl: z.string().optional(),
    dpdStatus: dpdStatusSnapshotSchema.optional(),
    dpdSync: dpdSyncSchema.optional(),
    collectionReschedule: collectionRescheduleSchema.optional(),
    parcelLabelResolution: parcelLabelResolutionSchema.optional(),
})
    .strict();
/** Identification et jalons de collecte du partenaire chargé d’un colis lourd. */
export const specialistAssignmentSchema = z
    .object({
    specialistId: z.string().min(1).optional(),
    transportPartner: z.string().min(1).optional(),
    collectionScheduledAt: persistedTimestampSchema.optional(),
    collectionCompletedAt: persistedTimestampSchema.optional(),
})
    .strict();
